import type { LoginMachine } from "@/data-interfaces/authentication";
import {
	type ApiError,
	GENERIC_ERROR_CODE,
	isApiError,
} from "@/data-interfaces/generics";

export const SSK_USERNAME = "username";
export const SSK_PASSWORD = "password";
export const SSK_JWT_TOKEN = "jwtToken";
export const SSK_REFRESH_SESSION_INTERVAL_SEC = "refreshSessionIntervalSec";
export const SSK_CLIENT_ID = "clientId";
export const SSK_SESSION_ID = "sessionId";
export const SSK_MACHINE = "machine";
export const SSK_MACHINE_INFO = "machineInfo";

export const getParsedSessionStorageItem = <T>(key: string): T | ApiError => {
	const value = sessionStorage.getItem(key);

	if (!value) {
		return {
			code: GENERIC_ERROR_CODE,
			error: `'${key}' not found in session storage`,
		};
	}

	try {
		return JSON.parse(value);
	} catch (error) {
		if (error instanceof Error) {
			return {
				code: GENERIC_ERROR_CODE,
				error: error.message,
			};
		}

		return {
			code: GENERIC_ERROR_CODE,
			error: "Generic error",
		};
	}
};

export const getMachineSerialNumber = (): string => {
	const machine = getParsedSessionStorageItem<LoginMachine>(SSK_MACHINE);

	if (isApiError(machine)) {
		console.warn("Error getting 'machine' from session storage");
		return "";
	}

	return machine.serial_number;
};

export const getMachineName = (): string => {
	const machine = getParsedSessionStorageItem<LoginMachine>(SSK_MACHINE);

	if (isApiError(machine)) {
		console.warn("Error getting 'machine' from session storage");
		return "";
	}

	return machine.name;
};
